import * as Actions from '../../store/action/investigation';

const initialState = {
  investigationData: [],
  selectedInvestigation: null, // New state piece for selected investigation
  loading: true,
};

const investigationReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.GET_INVESTIGATION:
      return {
        ...state,
        investigationData: action.payload,
        loading: false,
      };
    case Actions.GET_INVESTIGATION_BY_ID:
      return {
        ...state,
        selectedInvestigation: action.payload,
        loading: false,
      };
    case Actions.CREATE_INVESTIGATION:
      return {
        ...state,
        investigationData: [...state.investigationData, action.payload],
      };
    case Actions.UPDATE_INVESTIGATION:
      return {
        ...state,
        investigationData: state.investigationData.map((item) =>
            item._id === action.payload._id ? action.payload : item
        ),
      };
    case Actions.DELETE_INVESTIGATION:
      return {
        ...state,
        investigationData: state.investigationData.filter((item) => item._id !== action.payload),
      };
    case Actions.CLEAR_SELECTED_INVESTIGATION:
      return {
        ...state,
        selectedInvestigation: null,
      };
    default:
      return state;
  }
};

export default investigationReducer;
